import { Spin } from "Components/General/Spin";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import * as React from "react";
import { InformationTab } from "./InformationTab";

interface ProjectInformationModalProps {
  projectId: number;
}

export const ProjectInformationModal = ({ projectId }: ProjectInformationModalProps) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState<API_AccessRightsInfo>(null);
  const fetch = async () => {
    try {
      setLoading(true);
      const response = await API.getData(API_URL.REPORTS.getAccessRightsInfo(projectId));
      setData(response);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (projectId) {
      fetch();
    }
  }, [projectId]);

  return (
    <Spin spinning={loading}>
      <InformationTab data={data} />
    </Spin>
  );
};
